import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Sticky from 'react-stickynode';
import Top50Card from './top_50_card';
import Shuffler from './shuffler';
import matchMediaDesktop from '../../../utils/client_util';

class Top50Shuffle extends Component {
  constructor(props) {
    super(props);

    this.top50shuffle = React.createRef();

    this.state = {
      render: false
    };

    this.handleShuffle = this.handleShuffle.bind(this);

    this.randomRanks = [
      [36, 16, 26, 27, 1, 29, 43, 48, 10],
      [40, 3, 24, 32, 8, 4, 33, 17, 46],
      [14, 15, 20, 47, 42, 50, 38, 31, 28],
      [45, 34, 25, 18, 35, 49, 19, 6, 36],
      [39, 2, 13, 30, 21, 12, 7, 44, 8],
      [23, 42, 37, 41, 5, 22, 1, 9, 11]
    ];
    const p = 'portrait';
    const s = 'square';
    const d = 'digit';
    this.layout = [
      [s, s, d, s, p, p, p, d, s],
      [d, s, p, s, p, d, p, d, s],
      [s, p, d, d, p, p, s, d, d],
      [s, s, d, d, p, p, s, d, s],
      [p, d, s, d, s, d, p, d, p],
      [s, p, d, d, d, s, p, s, p]
    ];

    this.renderResize = this.renderResize.bind(this);
  }

  componentWillMount() {
    this.setState({
      render: true,
      slideIndex: 0,
      desktop: matchMediaDesktop('1024px')
    });
  }

  componentDidMount() {
    window.addEventListener('scroll', this.renderResize);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.renderResize);
  }

  handleShuffle() {
    let slideIndex;
    if (this.state.slideIndex === this.layout.length - 1) {
      slideIndex = 0;
    } else {
      slideIndex = this.state.slideIndex + 1;
    }

    this.top50shuffle.current.style.opacity = 0;

    setTimeout(() => {
      this.setState(
        {
          slideIndex
        },
        () => {
          this.top50shuffle.current.style.opacity = 1;
        }
      );
    }, 250);
  }

  renderDesktop() {
    const { slideIndex } = this.state;
    const { companies, config } = this.props;
    const layoutOrder = this.layout[slideIndex];
    const selection = this.randomRanks[slideIndex];

    const splitSelection = [
      [selection[0], selection[3], selection[6]],
      [selection[1], selection[4], selection[7]],
      [selection[2], selection[5], selection[8]]
    ];
    const layout = [
      [layoutOrder[0], layoutOrder[3], layoutOrder[6]],
      [layoutOrder[1], layoutOrder[4], layoutOrder[7]],
      [layoutOrder[2], layoutOrder[5], layoutOrder[8]]
    ];

    return splitSelection.map((section, idx) => (
      <div
        className={`top-50-shuffle__column ${`top-50-shuffle__column--${slideIndex}`}`}
        key={`desktop-${slideIndex}-col-${idx}`}
      >
        {section.map((rank, index) => (
          <Top50Card
            key={`desktop-${slideIndex}-rank-${idx}-${index}`}
            layout={layout[idx][index]}
            {...companies[rank - 1]}
            rank={rank - 1}
            slideIndex={slideIndex}
            config={config}
          />
        ))}
      </div>
    ));
  }

  renderResize() {
    const width = window.innerWidth;
    const { desktop } = this.state;

    if (desktop && width < 1024) {
      this.setState({ desktop: false });
    }

    if (!desktop && width >= 1024) {
      this.setState({ desktop: true });
    }
  }

  renderTablet() {
    const { slideIndex } = this.state;
    const { companies, config } = this.props;
    const layoutOrder = this.layout[slideIndex];
    const selection = this.randomRanks[slideIndex];

    const splitSelection = [
      [selection[0], selection[2], selection[4], selection[6], selection[8]],
      [selection[1], selection[3], selection[5], selection[7]]
    ];
    const layout = [
      [
        layoutOrder[0],
        layoutOrder[2],
        layoutOrder[4],
        layoutOrder[6],
        layoutOrder[8]
      ],
      [layoutOrder[1], layoutOrder[3], layoutOrder[5], layoutOrder[7]]
    ];

    return splitSelection.map((section, idx) => (
      <div
        className={`top-50-shuffle__column ${`top-50-shuffle__column--${slideIndex}`}`}
        key={`tablet-${slideIndex}-col-${idx}`}
      >
        {section.map((rank, index) => (
          <Top50Card
            key={`tablet-${slideIndex}-rank-${idx}-${index}`}
            layout={layout[idx][index]}
            {...companies[rank - 1]}
            rank={rank - 1}
            slideIndex={slideIndex}
            config={config}
          />
        ))}
      </div>
    ));
  }

  render() {
    if (!this.state.render) return null;

    return (
      <div className="top-50-shuffle">
        <div className="top-50-shuffle__scroller" id="top-50-shuffle__scroller">
          <Sticky
            top={100}
            bottomBoundary="#top-50-shuffle__scroller"
            enabled={this.state.render}
          >
            <div
              className="top-50-shuffle__shuffler"
              onClick={this.handleShuffle}
            >
              <div className="top-50-shuffle__shuffler-icon">
                <Shuffler />
              </div>
              Shuffle
            </div>
          </Sticky>
        </div>
        <div className="top-50-shuffle__content" ref={this.top50shuffle}>
          {this.state.desktop ? this.renderDesktop() : this.renderTablet()}
        </div>
      </div>
    );
  }
}

Top50Shuffle.propTypes = {
  companies: PropTypes.shape([]).isRequired,
  config: PropTypes.shape({}).isRequired
};

export default Top50Shuffle;
